<template>
<div :key="key" 
    :id="'order-template-item-search-product-' + product.productId"
    class="flex items-start gap-2 align-items-center h-[60px] py-3 border-b border-[#D1D1D1] hover:bg-[#F9F9F9] cursor-pointer"
    :class="[
        fullWidth ? 'w-full' : '!w-[442px]',
        { 'bg-[#FBEEEE]': isSelected, 'bg-[#F9F9F9]': isActive && !isSelected }
    ]"
    @click="onProductSelected()">
                <div class="min-w-[40px] min-h-[40px] w-[40px] h-[40px] rounded overflow-hidden flex items-center justify-center">
                    <img
                        v-if="getProductImageUrl(product)"
                        :src="getProductImageUrl(product)"
                        alt="Product Image"
                        class="w-[40px] h-[40px] object-cover object-center"
                    />
                    <div v-else class="w-full h-full rounded bg-gray-100 flex items-center justify-center text-gray-400 text-xs font-semibold">
                        No Image
                    </div>
                </div>

                <div class="text-sm">
                    <div class="text-sm text-[#838383] font-normal">{{ product.manufacturer || product.Manufacturer }}</div>
                    <div class="font-normal text-sm text-[#171717] block truncate w-[220px] md:w-[360px]">{{ product.productName  || product.ProductName}}</div>
                </div>
    </div>
</template>

<script setup lang="ts">

import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_PRODUCT_IMG } from "@/config/constants.js";

// Define emit events
const emit = defineEmits(['product-selected']);

const props = defineProps({
    product: {
    type: Object,
    required: true,
  },
  category: {
    type: Object,
    required: true,
  },
  key: {
    type: String,
    required: true,
  },
  /** Highlighted via keyboard navigation. */
  isActive: {
    type: Boolean,
    default: false,
  },
  /** Clicked/selected result. */
  isSelected: {
    type: Boolean,
    default: false,
  },
  /** Stretch the row (and its divider) to the container width instead of the fixed 442px. */
  fullWidth: {
    type: Boolean,
    default: false,
  }
});

function onProductSelected() {
  
    emit('product-selected', props.product);
};

const getProductImageUrl = (product) => {
  // Check for mediaAssets first (ProductPrimaryImage or ItemPrimaryImage)
  const primary = product?.mediaAssets?.find(a => 
    a.assetType === 'ProductPrimaryImage' || a.assetType === 'ItemPrimaryImage'
  );
  
  if (primary?.assetUri) {
    const uri = primary.assetUri;
    return uri.startsWith('http') ? uri : `${MEDIA_ASSET_BASE_URL}/${uri}`;
  }

  // Check for imageUrl property (various casings)
  const imageUrl = product?.imageUrl || product?.ImageUrl || product?.image || product?.Image;
  if (imageUrl) {
    if (imageUrl.startsWith('http')) return imageUrl;
    if (imageUrl.includes('/')) return `${MEDIA_ASSET_BASE_URL}/${imageUrl}`;
    return `${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_PRODUCT_IMG}${imageUrl}.jpg`;
  }

  // Check variants for images
  const variants = product?.variants || product?.Variants || [];
  if (variants.length > 0) {
    const variantImage = variants[0]?.mediaAssets?.[0]?.assetUri || variants[0]?.imageUrl || variants[0]?.ImageUrl;
    if (variantImage) {
      return variantImage.startsWith('http') ? variantImage : `${MEDIA_ASSET_BASE_URL}/${variantImage}`;
    }
  }
  
  // Return fallback placeholder
  return `${MEDIA_ASSET_BASE_URL}/image/upload/SRS/RoofHubAssets/VisualRefresh/Orders/noProduct.svg`;
}
</script>

<style >
</style>